import React, { useContext } from 'react';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { Button, Icon } from 'semantic-ui-react';
import { Form } from 'components/form-elements/Form';
import { Input } from 'components/form-elements/inputs/Input';
import { LabeledElement } from 'components/form-elements/labels/LabeledElement';
import { Text } from 'components/typography';
import { FormattedMessage } from 'react-intl';
import { Brikk } from '../../../../../../../Brikk';
// eslint-disable-next-line import/no-cycle
import { UserAdministrationModalContext } from '../../index';
import { ActionInput } from '../../../../../../../form-elements/inputs/ActionInput/ActionInput';
import styles from '../../styles.module.scss';
import { DiscardIcon } from '../../../../../../../../assets/icons/DiscardIcon';
import { MultiSelect } from '../../../../../../../form-elements/selects/MultiSelect';

const groupsAndPermissions = [{
  value: 'GH-2N-RECYCLING-USERS', label: 'GH-2N-RECYCLING-USERS',
}, {
  value: 'GH-2N-LAUNDRY-USERS', label: 'GH-2N-LAUNDRY-USERS',
}, {
  value: 'GH-2N-GARAGE-USERS', label: 'GH-2N-GARAGE-USERS',
}];
export const ManageService = () => {
  const { selectedUser, service, setService } = useContext(UserAdministrationModalContext);
  const { control, handleSubmit /* , watch, reset */ } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      selectedUser, tags: [{ value: '' }], licensePlates: [{ name: '' }],
    },
  });

  const { fields: tags, append: appendRfIdTag, remove: removeRfidTag } = useFieldArray({
    control, name: 'tags',
  });

  const { fields: licensePlates, append: appendLicensePlate, remove: removeLicensePlate } = useFieldArray({
    control, name: 'licensePlates',
  });

  const onSubmit = (/* data */) => {
    // updateServiceDetails(data);
  };

  return service ? (
    <>
      <Brikk.Heading
        heading="User Admin -> Configure Service"
      />
      <Text
        element="h2"
        thin
        xl
        size={20}
      >
        Service configuration
      </Text>
      <Text
        size={20}
      >
        {service} / {selectedUser.email}
      </Text>

      <Form
        className={styles.form}
        onSubmit={handleSubmit(onSubmit)}
      >

        {tags.map((field, index) => (
          <div
            key={field.id}
          >
            <LabeledElement
              label={index === 0 ? 'RIFD Tags' : ''}
              description={index === 0 ? 'Add one or more RFID tags IDs for this user' : ''}
              descriptionPosition="top"
            >
              <div
                className={styles.dynamicInputList}
              >
                <Input
                  placeholder={index === 0 ? 'Enter tag ID...' : ''}
                  id={`tags-${index}`}
                  type="text"
                />
                {tags.length > 1 && (
                <DiscardIcon
                  size={25}
                  onClick={() => removeRfidTag(index)}
                />
                )}
              </div>
            </LabeledElement>
          </div>
        ))}

        <Button
          onClick={() => appendRfIdTag({ name: '' })}
          className={styles.button}
        >
          <Text>
            Add another
          </Text>
          <Icon
            name="plus circle"
          />
        </Button>

        <ActionInput
          labelIntl="App connection"
          description="The user enters this code in the 2N app to activate it"
          descriptionPosition="top"
          id="appConnection"
          type="text"
          actionLabel="Fetch activation code"
        />
          
        {licensePlates.map((field, index) => (
          <div
            key={field.id}
          >
            <LabeledElement
              label={index === 0 ? 'License plates' : ''}
              description={index === 0 ? 'Add one or more license plates for this user' : ''}
              descriptionPosition="top"
            >
              <div
                className={styles.dynamicInputList}
              >
                <Input
                  placeholder={index === 0 ? 'ABC 123' : ''}
                  id={`licensePlates-${index}`}
                  type="text"
                />
                {licensePlates.length > 1 && (
                <DiscardIcon
                  size={25}
                  onClick={() => removeLicensePlate(index)}
                />
                )}
              </div>
            </LabeledElement>
          </div>
        ))}

        <Button
          onClick={() => appendLicensePlate({ name: '' })}
          className={styles.button}
        >
          <Text>
            Add another
          </Text>
          <Icon
            name="plus circle"
          />
        </Button>

        <Controller
          name="groupsAndPermissions"
          control={control}
          render={({ field }) => (
            <MultiSelect
                    // placeholder={intl.formatMessage({ id: 'chooseSourcePlaceholder' })}
              options={groupsAndPermissions}
              title="Groups and permissions"
                    //    description="chooseSourceDesc"
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
        <div className={styles.formButtons}>
          <Button
            basic
            name="cancel-service-details"
                    //   disabled={!hasChanges || isLoading}
                    //      loading={isLoading}
            size="small"
            intl="cancel"
            onClick={() => setService(null)}
          >
            <FormattedMessage id="Cancel" />
          </Button>
          {/*<Button*/}
          {/*  type="submit"*/}
          {/*  name="submit-service-details"*/}
          {/*          // disabled={!hasChanges || isLoading}*/}
          {/*          //  loading={isLoading}*/}
          {/*  size="small"*/}
          {/*  intl="save"*/}
          {/*/>*/}
          <Button
            type="submit"
            name="save-changes"
          >
            <FormattedMessage id="Save changes" />
          </Button>
        </div>

      </Form>
    </>
  ) : null;
};
